import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function CheckoutCancelPage() {
  return (
    <div className="pt-24 md:pt-28 min-h-screen container-custom" data-testid="checkout-cancel-page">
      <div className="text-center py-20 max-w-lg mx-auto">
        <XCircle size={64} className="text-[#FF3B30] mx-auto mb-6" />
        <h1 className="font-['Syne'] text-3xl font-bold mb-4">Payment Cancelled</h1>
        <p className="text-muted-foreground mb-8">
          Your payment was cancelled. Your cart items are still saved.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/cart">
            <Button className="btn-primary rounded-none" data-testid="return-to-cart-btn">
              Return to Cart
            </Button>
          </Link>
          <Link to="/shop">
            <Button variant="outline" className="btn-outline rounded-none" data-testid="continue-shopping-btn">
              Continue Shopping
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
